export default __webpack_public_path__ + "static/media/online-shop-3.f5e62bb2.png";